import { render } from "./SubunitDropdown.vue?vue&type=template&id=763705f9"
import script from "./SubunitDropdown.vue?vue&type=script&lang=js"
export * from "./SubunitDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__